<template>
  <div class="home">
    <HeadComponent msg="Welcome to Your Vue.js App"/>
    <!--el-header>
      <meta charset="UTF-8"> 
    </el-header-->
    <el-main>
      <div>
        未輸入問卷網址ID
      </div>
      
    </el-main>
  </div>
</template>


<style>
.card-container {
  margin-top: 20px;
}
.css-el-carousel .el-card__header{
  background: linear-gradient(90deg, rgb(25, 150, 170), rgba(25, 150, 170, 0.1));
}
.css-card-web-link .el-card__header{
  background: linear-gradient(90deg, #002f37, rgb(25 150 170 / 50%));
  font-size: larger;
  font-weight: 900;
  color: black;
  text-shadow: 0 0 10px #53b6bd;
}
.css-card-web-link .el-card__body{
  min-height: 145px;
}
.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    box-shadow: 0 2px 12px 0 rgb(55 96 103);
}
.el-card .is-always-shadow:hover{    
  background: linear-gradient(90deg, #002f37, rgb(0 0 0 / 50%));
  color: #fff;
  font-weight: 600;
  text-shadow: 0 0 10px #53b6bd;
}
</style>
<script>
import HeadComponent from '@/components/HeadComponent.vue';
//import { setJsonDateDecode } from "@/api/portalAction"
export default {
  name: 'HomeView',
  data() {
    return {
      isLogin: window.localStorage.isLogin,
      userName: window.localStorage.username
    };
  },
  mounted: function () {
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(`選中菜單項: ${key},${keyPath}`);
    }
  },
  components: {
    HeadComponent
  }
}
</script>
